// node modules
import Vue, { VNode } from 'vue'
import VueI18n from 'vue-i18n'
import VTooltip from 'v-tooltip'
import Toasted from 'vue-toasted'
import PortalVue from 'portal-vue'
import VueCookie from 'vue-cookie'
import Clipboard from 'v-clipboard'
import vClickOutside from 'v-click-outside'
import { VueMasonryPlugin } from 'vue-masonry'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueResource, { HttpOptions, HttpResponse } from 'vue-resource'
import ToggleButton from 'vue-js-toggle-button'

// bootstrap components, ONLY import what is needed to reduce size
import { BButton } from 'bootstrap-vue/esm/components/button'
import { BButtonGroup } from 'bootstrap-vue/esm/components/button-group'
import { BFormInput } from 'bootstrap-vue/esm/components/form-input'
import { BFormFile } from 'bootstrap-vue/esm/components/form-file'
import { BFormCheckbox } from 'bootstrap-vue/esm/components/form-checkbox'
import { BModal } from 'bootstrap-vue/esm/components/modal'
import {
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownForm,
} from 'bootstrap-vue/esm/components/dropdown'
import { CollapsePlugin } from 'bootstrap-vue/esm'

// FIXME: properly type storybook
// @ts-ignore
import AhaPresenter from '@mindthegapstudio/stpancras-storybook-app/src/AhaPresenter'
import mixpanelUtils from './utils/mixpanel.utils'
import i18nPlugin from '@/i18nPlugin'
import i18n from '@/i18n'
import i18nPresenter from '@/i18nPresenter'
import router from '@/router'
import store from '@/vuex/store'
import App from '@/App.vue'
import Config from '@/config'

// 3rd parties
import sentry from '@/services/sentry'

// plugins
import variblesPlugin from '@/plugins/varibles'
import functionsPlugin from '@/plugins/functions'

// photoswipe
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

// filters
import '@/filters'

// Import Amin Template
import '@/assets/scss-v2/styles.scss'
import '@/assets/scss/animate2.css'
import 'cropperjs/dist/cropper.css'
import '@fontsource/nunito'
import '@fontsource/nunito/600.css'
import './assets/tailwind.css'
import * as iconsMap from './fontAwesome'

// Custom directives
import vHoverIntent from '@/directives/hoverIntent'
import LazyLoadDirective from '@/directives/lazyload'

sentry.init()
mixpanelUtils.init()

Vue.use(Clipboard)
Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(VTooltip, {
  defaultOffset: 8,
  defaultTrigger: 'hover click',
})
Vue.use(ToggleButton)
Vue.use(VueI18n)
Vue.use(i18nPlugin, { i18nPresenter })
Vue.use(AhaPresenter);
(window as any).AHA_STORYBOOK_VERSION = AhaPresenter.version

Vue.use(vClickOutside)
Vue.use(VueMasonryPlugin)
Vue.use(Toasted, { duration: 5000, singleton: true })
Vue.use(PortalVue)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
library.add(iconsMap)

// bootstrap components, ONLY import what is needed to reduce size
Vue.component('BButton', BButton)
Vue.component('BButtonGroup', BButtonGroup)
Vue.component('BFormInput', BFormInput)
Vue.component('BFormFile', BFormFile)
Vue.component('BFormCheckbox', BFormCheckbox)
Vue.component('BModal', BModal)
Vue.component('BDropdown', BDropdown)
Vue.component('BDropdownDivider', BDropdownDivider)
Vue.component('BDropdownItem', BDropdownItem)
Vue.component('BDropdownForm', BDropdownForm)
// Vue.directive('outclick', {
//   bind(el, binding, vnode) {
//     el.clickOutsideEvent = function (event) {
//       // here I check that click was outside the el and his children
//       if (el != event.target) {
//         // and if it did, call method provided in attribute value
//         vnode.context[binding.expression](event)
//       }
//     }
//     document.body.addEventListener('click', el.clickOutsideEvent)
//   },
//   unbind(el) {
//     document.body.removeEventListener('click', el.clickOutsideEvent)
//   },
// })

Vue.use(CollapsePlugin)
// use custom plugins
Vue.use(variblesPlugin)
Vue.use(functionsPlugin)

// use custom directives
Vue.directive('hover-intent', vHoverIntent)
Vue.directive('lazy-load', LazyLoadDirective)

Vue.config.productionTip = false
if (Config.env === 'staging' || Config.env === 'dev') { // enable devtool for staging/ dev
  Vue.config.devtools = true
}

// If catch 401 in api other than in login page, redirect to login page
const AhaInterceptor = (request: HttpOptions, next: any): any => {
  const responseInterceptor = (response: HttpResponse): void => {
    if (!request.url) return

    if (request.url.includes('/api/auth/presenter')) return
    // if (response.status == 403) {
    //   if (request.url.includes('/api/slide/')
    //     || request.url.includes('/api/presentation/update/')
    //     || request.url.includes('/api/presentation/update-next-slide')
    //     || request.url.includes('/api/slide-option/')
    //   ) {
    //     window.location.reload()
    //     return
    //   }
    // }
    if (response.status !== 401) return

    store.commit('setIsTokenValid', false)
  }

  next(responseInterceptor)
}

Vue.http.interceptors.push(AhaInterceptor)

// eslint-disable-next-line import/prefer-default-export
export const app = new Vue({
  i18n,
  router,
  store,
  render: (h): VNode => h(App),
}).$mount('#app')
